import React from 'react'

export const AVAILABILITY_BADGE_APPEARANCES = {
  danger: 'danger',
  warning: 'warning',
  success: 'success',
} as const

export type OutletOption = {
  id: string
  name: string
  address?: string
  available?: number
}

export type OutletSelectProps = {
  outlets: OutletOption[]
  selectedOutletId?: string
  onOutletChange: (outlet: OutletOption) => void
  disabled?: boolean
  isLoading?: boolean
}

export type AvailabilityBadgeAppearance = typeof AVAILABILITY_BADGE_APPEARANCES[keyof typeof AVAILABILITY_BADGE_APPEARANCES]

export type OutletDropdownListOption = {
  label: string
  value: string
}

export type OutletDropdownListItemState = {
  selected: boolean
  highlighted: boolean
  disabled: boolean
}

export type OutletDropdownListProps = {
  items: Array<{ items: OutletDropdownListOption[] }>
  portalDisabled?: boolean
  portalTargetRef?: React.RefObject<HTMLElement>
  positioning?: {
    placement?: 'bottom-start'
    gutter?: number
    flip?: boolean
  }
  trapFocus?: boolean
  onSelect: (item: OutletDropdownListOption) => void
  customClasses?: Partial<
    Record<'positioner' | 'container' | 'header' | 'content', string>
  >
  headerSlot?: React.ReactNode
  triggerSlot?: React.ReactNode
  renderItem: (params: {
    item: OutletDropdownListOption
    props: React.HTMLAttributes<HTMLElement>
    state: OutletDropdownListItemState
  }) => React.ReactNode
  renderSection?: (params: {
    section: { items: OutletDropdownListOption[] }
    children: React.ReactNode
  }) => React.ReactNode
  footerSlot?: React.ReactNode
}
